var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('VueUEditor',{attrs:{"ueditorPath":_vm.ueditorPath,"ueditorConfig":_vm.ueditorConfig},on:{"ready":_vm.ueditorReady}})}
var staticRenderFns = []

export { render, staticRenderFns }